import styled from "styled-components";

export const Loading = styled.div`
  width: 100%;
  padding: 20px;
  text-align: center;
  color: #fff;
`;

export const Point = styled.div`
  height: 1px;
  background: red;
  width: 1px;
`;
